import { useEffect, useRef } from "react";

/**
 * A custom hook that runs an effect only on updates, skipping the initial mount.
 * @param {Function} effect - The callback function containing your logic.
 * @param {Array} dependencies - The dependency array for the effect.
 */
export function useUpdateEffect(effect, dependencies) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
